import { render, staticRenderFns } from "./CUGauge.vue?vue&type=template&id=bfe821ec"
import script from "./CUGauge.vue?vue&type=script&lang=ts"
export * from "./CUGauge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports